"use client";
import Newsletter from "@/components/Cards/Newsletter";
import SliderNoArrows from "@/components/Carousel/SliderNoArrows";
import Triangles from "@/components/Triangles";
import { NewsletterYellow } from "@/stories/Newsletter.stories";
import { TestemonialOrange } from "@/stories/Testemonial.stories";
import { shuffle, testimonialImg } from "@/utils";
import "@mantine/dropzone/styles.css";
import { useState } from "react";
import { SwiperSlide } from "swiper/react";
import testimonials from "../../../public/content/testimonials.json";
import videoTestimonials from "../../../public/content/videoTestimonials.json";
import PlayerInPage from "../Player/PlayerInPage";
import Testimonial from "../Text/Testimonial";
import FeedbackForm from "./FeedbackForm";
import { sendGTMEvent } from "../Analytics";

export default function KundenfeedbackLayout({
    sendEmail,
}: {
    sendEmail: (subject: string, data: object) => Promise<void>;
}) {
    const [openModal, setopenModal] = useState(false);

    return (
        <>
            <div className="bg-black w-full lg:py-44 px-6 lg:px-16 pb-16 flex-col justify-center items-center gap-6 inline-flex">
                <div className="container w-full py-20 px-3 space-y-4  gap-6 ">
                    <div className="flex flex-col justify-center">
                        <p className="text-white lg:text-xl3 text-2xl  text-center lg:text-center  font-bold">
                            Karin erlebte Mobbing
                        </p>
                        <p className="text-white lg:text-[80px] text-[40px] text-center lg:text-center font-bold leading-[52px] lg:leading-[80px]">
                            Nach Mobbing und schwerer Krise, fühle ich mich wieder
                            ausgeglichen
                        </p>
                        <div className=" text-center text-white text-lg lg:text-xl1 font-normal  leading-7 lg:leading-8.5">
                            Jahre lang begleitete Rico sie aus der Ferne
                        </div>
                    </div>
                    <div className="lg:block md:block hidden">
                        <SliderNoArrows
                            slidesPerView={1.5}
                            paginationColor="#FFF"
                            centered={false}
                            contentEl={
                                <div>
                                    {videoTestimonials.videoTestimonials.map(
                                        (testemonial) => (
                                            <SwiperSlide
                                                className="lg:pb-10 pb-2"
                                                key={testemonial.id}
                                            >
                                                <PlayerInPage
                                                    videoId={testemonial.id}
                                                    thumbnail={
                                                        testimonialImg.find(
                                                            (img) =>
                                                                img.name ===
                                                                testemonial.name,
                                                        )?.url
                                                    }
                                                />
                                            </SwiperSlide>
                                        ),
                                    )}
                                </div>
                            }
                        />
                    </div>
                    <div className="lg:hidden md:hidden block">
                        <SliderNoArrows
                            slidesPerView={1}
                            paginationColor="#FFF"
                            centered={false}
                            contentEl={
                                <div>
                                    {videoTestimonials.videoTestimonials.map(
                                        (testemonial) => (
                                            <SwiperSlide
                                                className="lg:pb-10 pb-2"
                                                key={testemonial.id}
                                            >
                                                <PlayerInPage
                                                    videoId={testemonial.id}
                                                    thumbnail={
                                                        testimonialImg.find(
                                                            (img) =>
                                                                img.name ===
                                                                testemonial.name,
                                                        )?.url
                                                    }
                                                />
                                            </SwiperSlide>
                                        ),
                                    )}
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>
            <div className="bg-black">
                <Triangles backgroundColor="bg-orange" buttomToTop={true} />
            </div>
            <div className="bg-orange flex justify-center">
                <div className="container w-full  px-3   flex-col justify-center items-center gap-6 inline-flex">
                    <SliderNoArrows
                        paginationColor="#000"
                        contentEl={
                            <div className="flex justify-center items-center">
                                {shuffle(testimonials?.testimonials)?.map(
                                    (testimonial) => {
                                        return (
                                            <SwiperSlide key={testimonial.testimonial}>
                                                <Testimonial
                                                    backgroundColor={
                                                        TestemonialOrange?.args
                                                            ?.backgroundColor
                                                    }
                                                    differentTextColor={
                                                        TestemonialOrange?.args
                                                            ?.differentTextColor
                                                    }
                                                    hasImage={testimonial.hasImage}
                                                    text={testimonial?.testimonial}
                                                    icon={TestemonialOrange.args?.icon}
                                                    textColor={
                                                        TestemonialOrange?.args
                                                            ?.textColor
                                                    }
                                                    name={testimonial?.name}
                                                    hasDescription={false}
                                                    wordsInDifferentColor={[""]}
                                                    hasReadMore={true}
                                                />
                                            </SwiperSlide>
                                        );
                                    },
                                )}
                            </div>
                        }
                    />
                </div>
            </div>
            <div className="bg-orange">
                <Triangles backgroundColor="bg-black" buttomToTop={false} />
            </div>
            <div className="bg-black flex justify-center">
                <div className="container w-full  px-3 ;  flex-col justify-center items-center gap-6 inline-flex">
                    <Testimonial
                        backgroundColor="bg-black"
                        text="VOLLTREFFER! Ja, Rico Brunner hat alles erkannt bzw. wahrgenommen, was mir zu schaffen macht und was ich erlebt habe und erlebe. "
                        textColor="text-white"
                        differentTextColor="text-turquoise"
                        name="Manuela Lenz"
                        hasImage={false}
                        hasDescription={false}
                        wordsInDifferentColor={["VOLLTREFFER!"]}
                        icon="/Icons/quoteIconTurquoise.svg"
                    />
                </div>
            </div>
            <div className="bg-black">
                <Triangles backgroundColor="bg-yellow" buttomToTop={true} />
            </div>
            <FeedbackForm
                sendEmail={sendEmail}
                openModal={openModal}
                closeModal={() => setopenModal(false)}
            />
            <div className="bg-yellow flex justify-center">
                <div className=" w-full  px-3  md:px-10 flex-col justify-center items-center gap-6 inline-flex">
                    <Newsletter
                        backgroundColor={NewsletterYellow.args?.backgroundColor}
                        hasCheckbox={NewsletterYellow.args?.hasCheckbox}
                        hasDescription={NewsletterYellow.args?.hasDescription}
                        hasInput={NewsletterYellow.args?.hasInput}
                        hasSubText={NewsletterYellow.args?.hasSubText}
                        title="Hast du Lust, mir ein Feedback zu geben?"
                        description="Dann sende es mir per Audio, Video oder als Text ;)"
                        buttonText="Jetzt Feedback senden"
                        onClickButton={() => {
                            setopenModal(true);
                            sendGTMEvent({
                                event: "cta_click",
                                section_title:
                                    "Hast du Lust, mir ein Feedback zu geben?",
                                section_index: "5",
                                cta_text: "Jetzt Feedback senden",
                                cta_link: "modal",
                            });
                        }}
                        buttonPaddings="px-2 lg:px-10 py-4"
                    />
                </div>
            </div>

            <div className="bg-yellow">
                <Triangles backgroundColor="bg-darkGray" buttomToTop={false} />
            </div>
        </>
    );
}
